import { render, staticRenderFns } from "./ListAtendimentos.vue?vue&type=template&id=35ed7804"
import script from "./ListAtendimentos.vue?vue&type=script&lang=js"
export * from "./ListAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports